import { autoinject } from 'aurelia-framework';
import { PenOrderStatusDto } from 'models/pen/PenOrderStatus';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenOrderStatusService extends BaseApiService<PenOrderStatusDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenOrderStatusDto);
  }
}
